import { AssessmentAPI } from '@oneapp/main/core/assessment/assessment.models';
import { Sport } from 'environments/environment';
import { StateSliceDefaults, StateSliceName } from '@oneapp/main/core/store.models';
import { UserAPI } from '@oneapp/main/core/user/user.models';
import { WorkflowPartnerAPI } from '@oneapp/main/core/workflow/workflow.models';

export interface AssignAssessmentDialogData {
    sport: Sport;
    assessment: AssessmentAPI;
    partners: WorkflowPartnerAPI[];
    userCompanyId: string;
}

export enum FilterAssigneesControlName {
    PARTNER_ID = 'partnerId',
    SEARCH_STRING = 'searchString'
}

export interface FilterAssigneesValues {
    [FilterAssigneesControlName.PARTNER_ID]?: string;
    [FilterAssigneesControlName.SEARCH_STRING]?: string;
}

export enum DualListActionsName {
    ADD = 'add',
    REMOVE = 'remove'
}

export interface AssignAssessmentDialogStateModel {
    selectedPartnerCompanyId: string | undefined;
    searchString: string;
    selectedAssigneeIds: string[];
    usersForCompany: UserAPI[] | undefined;
}

export const assignAssessmentDialogStateDefaults: StateSliceDefaults<AssignAssessmentDialogStateModel> = Object.freeze({
    sliceName: StateSliceName.ASSIGN_ASSESSMENT_DIALOG,
    defaults: {
        selectedPartnerCompanyId: undefined,
        searchString: '',
        selectedAssigneeIds: [],
        usersForCompany: undefined
    }
});
